"use strict";

(function() {
	const filtersBars = Array.from(document.querySelectorAll('.filters-bar'));
	if( filtersBars.length === 0 ) {
		return;
	}

	filtersBars.forEach(filtersBar => {
		
	});
})();